import { defineStore } from "pinia";

export interface ILoadingItem {
    id: string;
    message: string;
}

export const useLoadingStore = defineStore("LoadingStore", {
    state: () => ({
        loadingStack: [] as ILoadingItem[],
    }),
    getters: {
        isLoading() {
            return !!this.loadingStack.length;
        },
    },
    actions: {
        async addAsyncLoading(f: Function) {
            const id = `${+new Date()}`;
            this.addLoading({ id });
            await f();
            this.clearLoading(id);
        },
        addLoading(loadingItem: ILoadingItem) {
            if (!this.loadingStack.find((i) => i.id == loadingItem.id)) this.loadingStack.push(loadingItem);
        },
        clearLoading(id: string) {
            let idx = this.loadingStack.findIndex((i) => i.id == id);
            if (idx != -1) this.loadingStack.splice(idx, 1);
        },
    },
});
